import { render } from "./GPTPopover.vue?vue&type=template&id=7d348e8e&scoped=true"
import script from "./GPTPopover.vue?vue&type=script&lang=js"
export * from "./GPTPopover.vue?vue&type=script&lang=js"

import "./GPTPopover.vue?vue&type=style&index=0&id=7d348e8e&scoped=true&lang=css"

import exportComponent from "/home/gitlab-runner/builds/mFokeeiy/0/bpavone/detect-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7d348e8e"]])

export default __exports__